import React, { Component } from 'react';
import _ from 'lodash';

import TimeoutSignsTable from '../components/TimeoutSignsTable';
import TimeoutSignsSettingsForm from '../components/TimeoutSignsSettingsForm';
import TimeoutSignsMap from '../components/TimeoutSignsMap';

import TimeoutSignsModel from '../components/TimeoutSignsModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, Switch, Modal, message } from 'antd';
import TimeoutSignsParkinglocationsSelect from '../components/TimeoutSignsParkinglocationsSelect';

class TimeoutSignsScreen extends Component {

  state = {
    autoReload: (localStorage.getItem('table_autoReload') !== undefined && localStorage.getItem('table_autoReload') == 'true') ? true : false,
    dataLoading: true,
    dataAll: [],
    data: [],
    searchedTextValue: "",
    parkingLocationId: null,
    timeoutSignsSettingsFormModalVisible: false,
    mapModalVisible: false,
  }

  intervalId = null;

  componentWillMount() {
    this.loadData(this.state.parkingLocationId);

    // Checking auto reload data
    this.intervalId = setInterval(() => {
      if (this.state.autoReload) {
        this.loadData(this.state.parkingLocationId);;
      }
    }, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  loadData(parkingLocationId) {
    this.setState({
      dataLoading: true
    });
    TimeoutSignsModel.getAll(parkingLocationId)
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }

  onSearchDescription(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => {
        if (typeof (d['description']) != 'undefined') {
          return d['description'].toLowerCase().includes(searchText.toLowerCase());
        } else {
          return dataAll
        }
        if (searchText == '') {
          return dataAll
        }
      })
    });
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>Časovače - Seznam</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={8}>
                <TimeoutSignsParkinglocationsSelect
                  allowClear={true}
                  onChange={(value) => {
                    this.loadData(value);
                    this.setState({ searchedTextValue: "", parkingLocationId: value })
                  }}
                  style={{ width: 300 }}
                />
                <Input.Search
                  placeholder="Najít popis"
                  value={this.state.searchedTextValue}
                  onSearch={this.onSearchDescription.bind(this)}
                  onChange={(e) => {
                    this.setState({
                      searchedTextValue: e.target.value
                    })
                  }}
                  style={{ width: 200 }} />
              </Col>
              <Col span={10} offset={6} style={{ textAlign: 'right' }}>
                <Switch
                  checked={this.state.autoReload}
                  onChange={(checked) => {
                    localStorage.setItem('table_autoReload', checked);
                    this.setState({
                      autoReload: checked
                    });
                  }} /> Automatická obnova
                <Button type="default" onClick={() => { this.loadData(this.state.parkingLocationId) }} style={{ marginRight: 10, marginLeft: 15 }}><Icon type="sync" /></Button>
                {this.state.parkingLocationId
                  &&
                  <Button
                    type="default"
                    onClick={() => {
                      this.setState({ mapModalVisible: true })
                    }}
                    style={{ marginRight: 10, marginLeft: 10 }}>
                    <Icon type="environment" /> Mapa
                  </Button>
                }
                {UserModel.isInRoles(['ADMIN', 'TIMEOUTSIGNS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ timeoutSignsSettingsFormModalVisible: true }) }}>Nový časovač</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <TimeoutSignsSettingsForm
            type="modal"
            modalVisible={this.state.timeoutSignsSettingsFormModalVisible}
            onModalCancel={(form) => {
              form.resetFields();
              this.setState({ timeoutSignsSettingsFormModalVisible: false })
            }}
            onSuccess={(form, values) => {
              TimeoutSignsModel.create(values)
                .then(() => {
                  form.resetFields();
                  message.success("Časovač byl vložen!");
                  this.setState({ timeoutSignsSettingsFormModalVisible: false });
                  this.loadData(this.state.parkingLocationId);
                })
                .catch((err) => {
                  message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                });
            }} />

          <Modal
            title="Mapa"
            width={1200}
            visible={this.state.mapModalVisible}
            onCancel={(form) => {
              this.setState({ mapModalVisible: false })
            }}
            okButtonProps={{ disabled: true }}
            cancelButtonProps={{ disabled: true }}
            zIndex={9999}
            style={{ top: 20 }}
          >
            {this.state.mapModalVisible
              ? <TimeoutSignsMap
                signs={this.state.dataAll}
                center={{
                  lat: this.state.dataAll.length > 0
                    ? this.state.dataAll.map(s => s.coords.coordinates[1]).reduce((a, b) => a + b) / this.state.dataAll.length
                    : null,
                  lng: this.state.dataAll.length > 0
                    ? this.state.dataAll.map(s => s.coords.coordinates[0]).reduce((a, b) => a + b) / this.state.dataAll.length
                    : null
                }}
                zoom={this.state.dataAll.length > 0
                  ? 20
                  : 8
                }
              />
              : null}
          </Modal>

          <TimeoutSignsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onRowRemoved={() => {
              this.loadData(this.state.parkingLocationId);
            }}
            onAnyFormSuccess={() => {
              this.loadData(this.state.parkingLocationId);
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default TimeoutSignsScreen;



// WEBPACK FOOTER //
// ./src/screens/TimeoutSignsScreen.js